const API_BASE_URL_ENVIRONMENT_KEY = "VITE_API_BASE_URL";

/**
 * 管理画面からAPIへ接続するURLを生成する。
 *
 * ビルド時環境変数の読み取りとURLの正規化をこの関数へ集約し、
 * 各画面がAPIの基点URLを個別に扱わないようにする。
 *
 * @param path - APIパス。省略時は正規化した基点URLを返す
 * @param baseUrl - テストで固定する基点URL
 * @returns 生成したAPI URL
 */
export const createAdminApiUrl = (path = "", baseUrl?: string): string => {
  const resolvedBaseUrl = (baseUrl ?? import.meta.env.VITE_API_BASE_URL)?.trim();

  if (!resolvedBaseUrl) {
    throw new Error(`${API_BASE_URL_ENVIRONMENT_KEY} is required`);
  }

  const normalizedBaseUrl = resolvedBaseUrl.replace(/\/+$/u, "");

  if (path.length === 0) {
    return normalizedBaseUrl;
  }

  return new URL(path, `${normalizedBaseUrl}/`).toString();
};
